<cv-loader [size]="'medium'" [overlay]="true" *ngIf="loading"></cv-loader>
<cxone-modal #modal [headerTitle]="options?.modalTitle" [headerSubtitle]="options?.modalSubtitle" [allowClose]="true"
             [saveLabel]="options?.modalSaveLabel" [cancelLabel]="options?.modalCancelLabel" [focusOnShow]="true"
             [saveDisabled]="saveDisabled" (closed)="save()" (dismissed)="close()">
             <cxone-embedded-messages *ngIf="!isSingleAssignValid" class="single-assign-alert" 
                messageType="system-info" [messageData]="options?.singleAssignMessage" id="system-info"></cxone-embedded-messages>
    <cxone-add-entity *ngIf="!!entity" #cxAddEntity [entity]="entity" [ngClass]="!isSingleAssignValid ? 'single-assign-show-alert' : ''"></cxone-add-entity>
</cxone-modal>
